import { render, staticRenderFns } from "./RecruiterProgressBar.vue?vue&type=template&id=5aaaffc2&"
import script from "./RecruiterProgressBar.vue?vue&type=script&lang=js&"
export * from "./RecruiterProgressBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports